// Sunbrella Shade swatch grid — click-to-apply. Library was curated to 12
// solid colors (paste-in #26), so the collection filter UI was removed.
// On click: updates wizard.state.fabric and (if 3D mounted) calls onFabricChange.

import fabricsData from '../data/fabrics-sunbrella-shade.json';

const $  = (sel, root = document) => root.querySelector(sel);
const $$ = (sel, root = document) => root.querySelectorAll(sel);

const DEFAULT_SKU = '4674-0000';   // Linen — natural neutral, most homes look good with it.

export function bindFabricPicker(state, onFabricChange) {
  const grid = $('#fabric-grid');
  const currentEl = $('#fabric-current');
  if (!grid) return null;

  const fabrics = fabricsData.fabrics;

  function applyFabric(record) {
    state.set('fabric', record);
    if (currentEl) currentEl.textContent = `${record.name} · ${record.sku}`;
    $$('.fabric-swatch', grid).forEach(s => {
      s.classList.toggle('fabric-swatch--on', s.dataset.sku === record.sku);
    });
    if (onFabricChange) onFabricChange(record);
  }

  function render() {
    while (grid.firstChild) grid.removeChild(grid.firstChild);
    for (const f of fabrics) {
      const swatch = document.createElement('button');
      swatch.type = 'button';
      swatch.className = 'fabric-swatch';
      swatch.dataset.sku = f.sku;
      swatch.title = `${f.name} · ${f.sku}`;
      swatch.setAttribute('aria-label', f.name);
      swatch.setAttribute('style', `background:${f.hex};`);
      const name = document.createElement('span');
      name.className = 'fabric-swatch__name';
      name.textContent = f.name;
      swatch.appendChild(name);
      if (state.fabric && state.fabric.sku === f.sku) {
        swatch.classList.add('fabric-swatch--on');
      }
      swatch.addEventListener('click', () => applyFabric(f));
      grid.appendChild(swatch);
    }
  }

  // Pick a sensible default if none selected yet.
  if (!state.fabric) {
    const def = fabrics.find(f => f.sku === DEFAULT_SKU) || fabrics[0];
    if (def) applyFabric(def);
  } else if (currentEl) {
    currentEl.textContent = `${state.fabric.name} · ${state.fabric.sku}`;
  }

  render();
  return { applyFabric, render };
}
